<p>forgot-password-email-sent works!</p>
